import type { QueryClient } from '@tanstack/react-query'
import { footballMatchDetailParamsSchema } from '@ballpeek/api/client'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'
import { footballMatchDetailQueryOptions } from './query-options'

interface MatchDetailLoaderContext {
  queryClient: QueryClient
}
export function validateFootballMatchDetailRouteParams(params: { matchId: string } & Record<string, unknown>): void {
  parsePublicFootballRouteInput(footballMatchDetailParamsSchema, { matchId: params.matchId })
}

export async function loadFootballMatchDetailRoute(input: {
  context: MatchDetailLoaderContext
  params: { matchId: string }
}) {
  validateFootballMatchDetailRouteParams(input.params)
  await input.context.queryClient.prefetchQuery(
    footballMatchDetailQueryOptions(input.params.matchId),
  )
}
